export type Breadcrumb = {
  type?: string;
  category?: string;
  message?: string;
  level?: 'debug' | 'info' | 'error' | 'warning';
  data?: any;
};

export type TelemetryIdentity = {
  id: string;
  email?: string;
  accountId?: string;
};

export type BuildInfo = {
  name?: string;
  hostVersion?: string;
  pluginVersion?: string;
  version?: string;
  schemaVersion?: string;
  uiLocale?: string | null;
};

export type IdentifyOptions = {
  buildInfo?: BuildInfo;
  identifyOptions?: {
    accountId?: string;
  };
  integrations?: Record<string, boolean | Record<string, unknown>>;
};

export const WORKER_ERROR_EVENT = 'telemetry-worker-error';
export const WORKER_EMIT_EVENT = 'telemetry-worker-event';
